import {Component} from '@angular/core';

@Component({
  selector: 'home-button',
  templateUrl: './home-button.component.html',
  styleUrls: ['./home-button.component.less']
})
export class HomeButtonComponent {
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/home-button/home-button.component.ts